module.exports = __webpack_public_path__ + "assets/overlay-left-side.eda644c54a1cf70bb3cdc2348189d079.png";